import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { Expression } from '../../data/text-or-code.js'
import { TextOrCode_assumeCode } from '../../data/text-or-code.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'

@jsonClass('CardBlock')
export class CardBlock extends Block {
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Title text (in header)',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		alternativeContentAreaName: 'title',
	})
	@jsonProperty(TextOrExpression_assumeExpression)
	titleCode = new TextOrExpression_assumeExpression('', 'T')

	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Elevation level (0-24)',
		codeLanguage: 'ts',
		tsReturnType: () => 'number',
		editorSize: 'singleline',
		isBinding: false,
	})
	@jsonProperty(Expression)
	elevationCode = new Expression('')

	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: 'Sub-title text (in header)',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		alternativeContentAreaName: 'subtitle',
	})
	@jsonProperty(TextOrExpression_assumeExpression)
	subtitleCode = new TextOrExpression_assumeExpression('', 'T')

	@ScreenEditorInput({
		inputType: 'code',
		order: 3,
		label: 'Avatar text (top-left)',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		alternativeContentAreaName: 'avatar',
	})
	@jsonProperty(TextOrExpression_assumeExpression)
	avatarCode = new TextOrExpression_assumeExpression('', 'T')

	@ScreenEditorInput({
		inputType: 'code',
		order: 4,
		label: 'Text before content (full-width)',
		tooltip: () => ({
			text: 'This is useful to show full-width elements before the content area (which has a padding on it), e.g. a full-width image',
		}),
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		alternativeContentAreaName: 'beforeContent',
	})
	@jsonProperty(TextOrExpression_assumeExpression)
	beforeContentCode = new TextOrExpression_assumeExpression('', 'T')

	@ScreenEditorInput({
		inputType: 'code',
		order: 4,
		label: 'Actions text (below content)',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		alternativeContentAreaName: 'actions',
	})
	@jsonProperty(TextOrExpression_assumeExpression)
	actionsCode = new TextOrExpression_assumeExpression('', 'T')

	@ScreenEditorInput({
		inputType: 'code',
		order: 5,
		label: 'Footer text',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		alternativeContentAreaName: 'footer',
	})
	@jsonProperty(TextOrExpression_assumeExpression)
	footerCode = new TextOrExpression_assumeExpression('', 'T')

	constructor(init: Partial<CardBlock> = {}) {
		super()
		this.init(init)
	}

	getTitleBackgroundAndBorderColor(): string {
		return '#b0bec5'
	}

	getTitleColor(): string {
		return '#263238'
	}

	getEditorCategory(): string {
		return 'Layout'
	}
}
